import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import CheckBlueIcon from "../../../utils/Icons/CheckBlueBg";
import { activateEmployeeRequest } from "../../../store/Employees/actions";

const ReactivateEmployeeModal = ({
  open,
  closeModal,
  employeeInfo
}) => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const { employees, shared } = messages[lang];

  const handleConfirmActivation = () => {
    dispatch(activateEmployeeRequest({ id: employeeInfo?.id }));
    closeModal();
  };

  return (
    <Modal
      open={open}
      handleConfirm={handleConfirmActivation}
      handleClose={closeModal}
      isContentText={false}
      content={
        <div className="deactivate-employee-container container d-flex flex-column justify-content-center align-items-center">
          <CheckBlueIcon />
          <div className="deactivate-employee-content mt-2 d-flex flex-column justify-content-center align-items-center text-center">
            <Typography className="fsize-20 fweight-700">
              {`${employees.reactivateEmployee.content} "${employeeInfo.Name}" !`}
            </Typography>
            <Typography className="text-secondary fsize-14 mt-2 fweight-600">
              {employees.reactivateEmployee.confirmationContent}
            </Typography>
          </div>
        </div>
      }
      hasActions={true}
      confirmBtnTxt={shared.reactivate}
      cancelBtnTxt={shared.cancel}
      handleCancel={closeModal}
      showCloseIcon
      title
      maxWidth={"xs"}
    />
  );
};

ReactivateEmployeeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  employeeInfo: PropTypes.object.isRequired
};

export default ReactivateEmployeeModal;
